import { directiveConfig } from '../utils/helpers'

function directive (el, binding) {
  const config = directiveConfig(
    binding,
    {
      overlap: false,
      
      left: false,
      right: false,

      top: false,
      bottom: false,

      small: false,
    }
  )

  if (config.overlap) el.classList.add('badge--overlap')
  if (config.left) el.classList.add('badge--left')
  if (config.right) el.classList.add('badge--right')
  if (config.top) el.classList.add('badge--top')
  if (config.bottom) el.classList.add('badge--bottom')
  if (config.small) el.classList.add('badge--small')
  if(config.value === true) el.classList.add('badge--pin')


  //el.dataset.badge = config.value // IE 11 is not a fan
    if(config.value !== true) {
        el.setAttribute('data-badge', config.value.toString())
    }
  el.classList.add('badge')
}

export default {
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: (el) => {
    el.removeAttribute('data-badge')
    el.classList.remove('badge')
  }
}
